import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ArrowIcon from "./ArrowIcon";
// import useWindowDimensions from "../utils/useWindowDimensions";

const ScrollToTop = ({
  styles,
  showBelow,
}: {
  styles?: React.CSSProperties;
  showBelow?: number;
}): JSX.Element => {
  //   const { windowWidth } = useWindowDimensions();

  const [visible, setVisible] = useState(!showBelow ? true : false);

  useEffect(() => {
    if (showBelow) {
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }
  });

  const onScroll = () => {
    showBelow && window.pageYOffset > showBelow
      ? setVisible(true)
      : setVisible(false);
  };

  const onClick = () => {
    window["scrollTo"]({ top: 0, behavior: "smooth" });
  };

  return (
    <BackToTopContainer
      style={styles}
      // windowWidth={windowWidth}
    >
      {visible && <ArrowIcon onClick={onClick} />}
    </BackToTopContainer>
  );
};

// const BackToTopContainer = styled.div<{
//   windowWidth: number;
// }>`
//   z-index: 10;
//   position: fixed;
//   right: ${(props) =>
//     props.windowWidth < props.theme.screenSize.l + 50
//       ? "1rem"
//       : props.windowWidth > props.theme.screenSize.xl
//       ? `${(props.windowWidth + 50 - props.theme.screenSize.xl) / 2}px`
//       : "2rem"};
//   bottom: ${(props) =>
//     props.windowWidth && props.windowWidth < props.theme.screenSize.l + 40
//       ? "1rem"
//       : "2rem"};
// `;
const BackToTopContainer = styled.div`
  z-index: 10;
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  @media (max-width: ${(props) => props.theme.screenSize.l}px) {
    right: 1rem;
    bottom: 1rem;
  }
`;

export default ScrollToTop;
